import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import "./HeaderForm.scss";

const items = [
  {
    link: "/nouveau-dossier",
    title: "Exercice",
  },
  {
    link: "/dossier/adresse",
    title: "Adresse",
  },
  {
    link: "/dossier/votre-bien",
    title: "Votre bien",
  },
  {
    link: "/dossier/votre-activite",
    title: "Votre activité [year]",
  },
  {
    link: "/dossier/votre-liasse-fiscale",
    title: "Votre liasse fiscale",
  },
];

class HeaderForm extends Component {
  render() {
    let step = 0;
    let annee = "";
    if (this.props.step !== null) {
      step = parseInt(this.props.step);
    }
    let dossier = null;
    if (this.props.dossier !== null) {
      dossier = this.props.dossier;

      if (dossier.annee) {
        annee = dossier.annee;
      }
    }

    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            {this.props.isReadOnlyForm ? (
              <ul className="nav" id="header-form">
                {items.map((item, key) => (
                  <li className="nav-item" key={key}>
                    <Link
                      to={item.link}
                      className={`${step === key ? "active " : ""}`}
                    >
                      {item.title.replace("[year]", annee)}
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <ul className="nav" id="header-form">
                {items.map((item, key) => (
                  <li className="nav-item" key={key}>
                    <Link
                      to={step >= key ? item.link : ""}
                      className={`${step === key ? "active " : ""}${
                        key > step ? "disabled-link" : ""
                      }`}
                    >
                      {item.title.replace("[year]", annee)}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dossier: state.dossiers.dossier,
    isFetching: state.dossiers.fetching,
    error: state.dossiers.error,
    errorMessage: state.dossiers.errorMessage,
  };
};

export default connect(mapStateToProps, null)(HeaderForm);
